import { forwardRef } from 'react';
import * as THREE from 'three';

import { BOX_SIZE } from './physics-constants';

type Props = {
	color: string;
};

const EnergyMesh = forwardRef<THREE.Mesh, Props>(({ color }, ref) => {
	return (
		<mesh ref={ref} castShadow receiveShadow>
			<boxGeometry args={[BOX_SIZE, BOX_SIZE, BOX_SIZE]} />
			<meshStandardMaterial
				color={color}
				roughness={0.55}
				metalness={0.15}
			/>
		</mesh>
	);
});

EnergyMesh.displayName = 'EnergyMesh';

export default EnergyMesh;
